import { FC, ReactNode } from 'react';

//import { selectIsLoggedIn } from '../store/reducers/login-slice';

export interface ProtectedRouteNavigationState {
  from: string;
}

interface Props {
  children: ReactNode;
}

export const ProtectedRoute: FC<Props> = ({ children }) => {
  //const isLoggedIn = useSelector(selectIsLoggedIn);
  //const location = useLocation();

  /*if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }*/

  return <>{children}</>;
};
